/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { API_PATH } from "./../environments/config";
@Injectable({
  providedIn: "root",
})
export class CheckImageUrlService {
  constructor() {}

  verifyImage(data: string) {
    if (data) {
      if (!data.startsWith("http")) {
        return API_PATH.apis.server + "/" + data;
      } else {
        return data;
      }
    }
  }
}
